import React, { useCallback, useState } from 'react'
import { CCard, CCardBody, CCol, CRow } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilHistory, cilPeople, cilSwapHorizontal } from '@coreui/icons'
import UserTrade from './UserTrade'
import TradeLog from './TradeLog'
import './Trades.css'

const USED = 'used'
const LOG = 'log'

const TABS = [
  { key: USED, label: 'Trades Used' },
  { key: LOG, label: 'Trades Log' },
]

const Trades = () => {
  const [activeTab, setActiveTab] = useState(USED)
  // Both panels stay mounted so each tab's count is known before it is opened, and so
  // switching tabs keeps the paging/search the admin had set.
  const [totals, setTotals] = useState({ [USED]: null, [LOG]: null })
  const [allowance, setAllowance] = useState(null)

  // Stable per-tab reporters: the panels keep these in their fetch dependencies.
  const setTotal = useCallback(
    (key, total) =>
      setTotals((current) => (current[key] === total ? current : { ...current, [key]: total })),
    [],
  )
  const setUsedTotal = useCallback((total) => setTotal(USED, total), [setTotal])
  const setLogTotal = useCallback((total) => setTotal(LOG, total), [setTotal])

  const STAT_CARDS = [
    { label: 'Members Trading', value: totals[USED], icon: cilPeople, color: 'primary' },
    { label: 'Trades Per Member', value: allowance, icon: cilSwapHorizontal, color: 'info' },
    { label: 'Trade Entries', value: totals[LOG], icon: cilHistory, color: 'success' },
  ]

  return (
    <>
      <div className="ge-page-header">
        <h1 className="ge-page-title">Trades</h1>
        <p className="ge-page-subtitle">
          How many trades each member has used and left, and every trade made this season.
        </p>
      </div>

      <CRow className="g-3 mb-3">
        {STAT_CARDS.map((s) => (
          <CCol sm={6} lg={4} key={s.label}>
            <CCard className="h-100">
              <CCardBody className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="text-medium-emphasis small">{s.label}</div>
                  <div className="fs-4 fw-semibold">{s.value ?? '—'}</div>
                </div>
                <div className={`ge-stat-icon ge-stat-icon--${s.color}`}>
                  <CIcon icon={s.icon} size="lg" />
                </div>
              </CCardBody>
            </CCard>
          </CCol>
        ))}
      </CRow>

      <div className="ge-tabs" role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.key}
            className={`ge-tab${activeTab === tab.key ? ' active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
            {totals[tab.key] !== null && <span className="ge-tab-count">{totals[tab.key]}</span>}
          </button>
        ))}
      </div>

      <CCard className="tr-panel">
        <CCardBody>
          <div className={activeTab === USED ? undefined : 'd-none'}>
            <UserTrade onTotalChange={setUsedTotal} onAllowanceChange={setAllowance} />
          </div>
          <div className={activeTab === LOG ? undefined : 'd-none'}>
            <TradeLog onTotalChange={setLogTotal} />
          </div>
        </CCardBody>
      </CCard>
    </>
  )
}

export default Trades
